import React from 'react';
import { FadeIn } from './FadeIn';
import { Button } from './Button';
import { Sparkles } from 'lucide-react';
export const HeroSection = () => {
  return <section className="relative min-h-screen flex items-center justify-center pt-20 pb-32 px-4 overflow-hidden" data-id="element-89">
      {/* Background Effects */}
      <div className="absolute inset-0 bg-stars pointer-events-none" data-id="element-90"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] bg-radial-gold pointer-events-none" data-id="element-91"></div>

      <div className="max-w-5xl mx-auto relative z-10 text-center" data-id="element-92">
        <FadeIn delay={0.1} data-id="element-93">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-gold-antique/40 bg-gold-light/30 text-gold-antique text-sm font-medium tracking-widest uppercase mb-8" data-id="element-94">
            <Sparkles size={16} data-id="element-95" />
            
          </div>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-96">
          <h1 className="font-playfair text-5xl md:text-6xl lg:text-7xl font-bold leading-tight mb-6 text-brown-espresso" data-id="element-97">
            RENACER: El Protocolo Cuántico para{' '}
            <span className="gold-gradient-text" data-id="element-98">Colapsar el Trauma</span> y
            Hackear tu Realidad
          </h1>
        </FadeIn>

        <FadeIn delay={0.3} data-id="element-99">
          <h2 className="text-xl md:text-2xl text-brown-warm font-light max-w-3xl mx-auto leading-relaxed mb-12" data-id="element-100">
            Deja de repetir tu pasado y aprende a sintonizar la línea de tiempo
            donde tu sanación, propósito y abundancia ya son una realidad
            física.
          </h2>
        </FadeIn>

        <FadeIn delay={0.4} className="mb-12" data-id="element-101">
          <div className="relative inline-block" data-id="element-102">
            <div className="absolute inset-0 bg-gold/15 blur-3xl rounded-full" data-id="element-103"></div>
            <img src="https://cdn.magicpatterns.com/uploads/aeREA2C6qb4bNHHf6nm1Ln/RENACER.png" alt="RENACER Protocolo Cuántico" className="relative z-10 w-full max-w-2xl mx-auto rounded-xl gold-glow" data-id="element-104" />
          </div>
        </FadeIn>

        <FadeIn delay={0.5} data-id="element-105">
          <Button className="text-lg md:text-xl px-10 py-5" onClick={() => document.getElementById('pricing')?.scrollIntoView({
          behavior: 'smooth'
        })} data-id="element-106">
            RECLAMAR MI RENACER AHORA
          </Button>
          <p className="mt-4 text-sm text-brown-warm/60" data-id="element-107">
            Tu transformación comienza en el punto cero.
          </p>
        </FadeIn>
      </div>
    </section>;
};